var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('router-link',{attrs:{"to":"/customer"}},[_vm._v(_vm._s(_vm.$t('home.text.customer')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }